import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.jsx';
import { colors } from '../../utils/colors.js';
import { APP_NAME } from '../../config/api.js';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.gradients.primary};
  padding: 16px;
`;

const Card = styled.form`
  background: ${colors.white};
  border-radius: 16px;
  padding: 40px 32px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h1`
  font-size: 22px;
  margin: 0 0 4px;
  color: ${colors.gray[900]};
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: ${colors.gray[500]};
  margin: 0 0 24px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.gray[700]};
  margin-bottom: 6px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${colors.gray[300]};
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 16px;

  &:focus {
    outline: none;
    border-color: ${colors.primary[500]};
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: ${colors.gradients.primary};
  color: ${colors.white};
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    filter: brightness(1.05);
  }
`;

const ErrorMessage = styled.div`
  background: ${colors.error.light};
  color: ${colors.error.dark};
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
`;

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Email ou senha inválidos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card onSubmit={handleSubmit}>
        <Title>{APP_NAME}</Title>
        <Subtitle>Acesso restrito à equipe da plataforma</Subtitle>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="admin@checkin.space"
          required
          autoFocus
        />

        <Label htmlFor="password">Senha</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />

        <Button type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </Button>
      </Card>
    </Container>
  );
}
